/** Beak chevron (‹ / ›) — thick stroke, no shaft (matches customer Retail V1 chrome). */

export function AdminBeakChevron({
  direction = 'right',
  className = 'h-5 w-5 shrink-0 text-current',
}: {
  readonly direction?: 'left' | 'right';
  readonly className?: string;
}): JSX.Element {
  const d =
    direction === 'left' ? 'M12 5.25 6.75 10 12 14.75' : 'M8 5.25 13.25 10 8 14.75';

  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <path
        d={d}
        stroke="currentColor"
        strokeWidth="2.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
